function SoftverVTepTechnike(){
    return(
        <div>
            SoftverVTepTechnike
        </div>
    );
};

export default SoftverVTepTechnike;